webpackJsonp([34],{

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ba5f41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vux-x-dialog" },
    [
      _c("transition", { attrs: { name: _vm.maskTransition } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show"
            }
          ],
          staticClass: "weui-mask",
          style: _vm.maskStyle,
          on: { click: _vm.hide }
        })
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: _vm.dialogTransition } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show"
              }
            ],
            class: _vm.dialogClass,
            style: _vm.dialogStyle
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74ba5f41", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("5C0z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vux/src/components/x-dialog/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74ba5f41", Component.options)
  } else {
    hotAPI.reload("data-v-74ba5f41", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/uEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


/* eslint-disable */
var Wu = function Wu() {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Wu);

	//判断是否可以删除组件
	this.canRemove = true;
	//loading 节点
	this.iosLoading = '<i class="wu-icon wu-loading"></i>';
};

/* 
 * 把生成的组件添加到dom里
 * 
 * ## 在vue里添加到实例vue的dom元素里
 * ## 其他根据自己业务添加到对应的元素里
 */


Wu.prototype.addDom = function (el) {
	//vue
	document.querySelector('#app').appendChild(el);
	//普通页面
	//document.body.appendChild(el);
};

/*
 *  按钮触碰状态
 */
Wu.prototype.hoverButton = function () {

	var i,
	    len,
	    btns = document.querySelectorAll('.wu-btn');

	for (i = 0, len = btns.length; i < len; i++) {

		btns[i].addEventListener('touchstart', function () {
			this.classList.add('wu-btn-hover');
		});
		btns[i].addEventListener('touchend', function () {
			this.classList.remove('wu-btn-hover');
		});
	}
};

/* 
 * 显示loading
 * @param {string} title 要显示的说明文字，可不添加
 * 
 */
Wu.prototype.showLoading = function (title) {

	var load = document.querySelector(".wu-toast");
	if (load) {
		load.parentNode.removeChild(load);
	};

	var $this = this;
	var n = title ? title : '';
	var el = document.createElement("div");
	var span = '<span class="wu-toast-content">' + n + '</span>';
	var h = '<div class="wu-mask-transparent"></div>' + '<div class="wu-toast-box wu-toast-loading">' + $this.iosLoading + (title ? span : '') + '</div>';

	el.innerHTML = h;
	el.className = 'wu-toast';

	wu.addDom(el);

	setTimeout(function () {
		el.classList.add('wu-animate-in');
	}, 0);
};

/* 
 * 显示loading 背景和 logo 
 */
Wu.prototype.showLoadingBg = function () {

	wu.hideToast();

	var $this = this;
	var el = document.createElement("div");
	var h = '<div class="wu-mask-transparent bg-white"></div>' + '<div class="wu-toast-box wu-toast-box-transparent">' + $this.iosLoading + '</div>';
	el.innerHTML = h;
	el.className = 'wu-toast';

	wu.addDom(el);

	setTimeout(function () {
		el.classList.add('wu-animate-in');
	}, 0);

	return false;
};

/*
 *  隐藏 toast
 */
Wu.prototype.hideToast = function () {

	var el = document.querySelector('.wu-toast');
	var $this = this;

	if (el) {
		if ($this.canRemove) {
			$this.canRemove = false;
			el.classList.add('wu-animate-out');
			el.addEventListener('webkitTransitionEnd', function () {
				el.remove();
				$this.canRemove = true;
			});
		}
	};
	return false;
};

/* 
 *  wu.showError(); 显示连接失败错误提示
 *  @param {string} title 要显示的说明文字，可不添加
 */
Wu.prototype.showError = function (title) {

	wu.hideToast();
	var t = title || '网络请求超时，轻触屏幕刷新';
	var el = document.createElement("div");
	el.innerHTML = '<div class="start-box-refresh"><div class="start-box-icon">' + '<i class="wu-icon icon-refresh"></i></div>' + '<p class="refresh-text">' + t + '<p>' + '</div>';
	el.className = 'wu-toast';

	wu.addDom(el);

	setTimeout(function () {
		el.classList.add('wu-animate-in');
	}, 0);

	document.querySelector(".start-box-refresh").addEventListener("click", function () {
		location.reload();
	});
	return false;
};

/* 
 *  显示toast
 * 
 *  @param {object} obj 相关配置
 * 
 *  wu.showToast({
		title:'操作成功',
		mask:false,
		icon:'icon-success',    // icon-success | icon-error | icon-info
		duration:3000
	});  
 */
Wu.prototype.showToast = function (obj) {

	wu.hideToast();

	var title = obj.title,
	    ismask = obj.mask ? true : false,
	    icon = obj.icon || '',
	    duration = obj.duration || 3000;

	if (typeof obj == 'string') {
		title = obj;
	};

	var el = document.createElement("div");
	var mask = '<div class="wu-mask-transparent"></div>';
	var iconLoad = '<i class="wu-icon wu-icon-toast ' + icon + '"></i>';
	var span = '<span class="wu-toast-content">' + title + '</span>';

	var h = (ismask ? mask : '') + '<div class="wu-toast-box">' + (icon ? iconLoad : '') + (title ? span : '') + '</div>';

	el.innerHTML = h;
	el.className = 'wu-toast';

	wu.addDom(el);

	setTimeout(function () {
		el.classList.add('wu-animate-in');
	}, 0);

	//定时关掉
	setTimeout(function () {
		el.classList.add('wu-animate-out');
		el.addEventListener('webkitTransitionEnd', function () {
			el.remove();
		});
	}, duration);

	return false;
};

/* 
 *  显示头部滑出的消息提示
 * 
 *  @param {object} obj 相关配置
 * 
 *  wu.showMessage({
		title: "输入错误",
		backgroundColor: 'rgba(255, 0, 0, 0.5)',  // #fff | rgb/rgba 
		duration: 3000
	}); 
 */
Wu.prototype.showMessage = function (obj) {

	wu.hideToast();

	var is_el = document.querySelector('.wu-message');
	if (!is_el) {
		var el = document.createElement("div");
		var title = obj.title || '未知错误',
		    top = obj.top || '0',
		    duration = obj.duration || 3000,
		    bgColor = obj.backgroundColor || 'rgba(17, 17, 17, 0.9)',
		    color = obj.color || '#FFF';

		var h = '<span class="wu-toast-content">' + title + '</span>';

		el.className = 'wu-message';
		el.style.backgroundColor = bgColor;
		el.style.color = color;
		el.innerHTML = h;

		wu.addDom(el);

		setTimeout(function () {
			el.style.top = top + "px";
		}, 0);

		setTimeout(function () {
			el.style.top = "-44px";
			el.addEventListener('webkitTransitionEnd', function () {
				this.remove();
			});
		}, duration);
	}

	return false;
};

/*
 *  显示操作窗口
 * 
 *  @param {object} ops 相关配置
 * 
 *  wu.showDialog({
		title: 'Hello Wu-ui',
		content: '欢迎使用Wu-ui',
		showCancel: true,
		showInput: false,
		success: function (res) {              //res.val == "confirm ||cancel"  // res.inputVal == "输入框的值"
			if(res.val == "confirm") {
				wu.showToast({
					title: '点击了确定',
					duration:2500
				})
			}
			if(res.val == "cancel") {
				wu.showToast({
					title: '点击了取消'
				})
			}
		}
	})
 */
Wu.prototype.showDialog = function (ops) {

	var title = ops.title || '提示',
	    desc = ops.content || '',
	    showCancel = ops.showCancel ? true : false,
	    showInput = ops.showInput ? true : false;

	var el = document.createElement("div");
	var content_text = '<div class="dialog-text">' + desc + '</div>';
	var content_input = '<div class="dialog-input"><input type="text" class="dialog-prompt" autofocus /></div>';

	var h = '<div class="wu-mask-transparent wu-mask-black"></div>' + '<div class="dialog-content">' + '<div class="dialog-title">' + title + '</div>' + '<div class="dialog-body">' + (showInput ? content_input : content_text) + '</div>' + '<div class="dialog-foot">' + '<a class="wu-btn dialog-btn-cancel" style="' + (showCancel ? '' : 'display: none') + '">取消</a>' + '<a class="wu-btn dialog-btn-confirm">确认</a>' + '</div></div>';

	el.className = 'wu-dialog';
	el.innerHTML = h;

	wu.addDom(el);
	wu.hoverButton();

	setTimeout(function () {
		el.classList.add('wu-animate-in');
	}, 0);

	document.body.addEventListener('click', dialogHandlerr, false); //监听按钮点击

	function dialogHandlerr(e) {

		var e = e || window.event;
		var target = e.target || e.srcElement;
		var cls = target.className;

		if (cls.indexOf('dialog-btn-confirm') >= 0) {

			//确认
			if (showInput) {
				//如果显示输入框

				var input_val = document.getElementsByClassName('dialog-prompt')[0].value;

				if (typeof ops.success == 'function') {
					ops.success({
						value: 'confirm',
						inputValue: input_val
					});
				}
			} else {

				if (typeof ops.success == 'function') {
					ops.success({
						value: 'confirm'
					});
				}
			}
			removeDialog();

			return false;
		}
		if (cls.indexOf('dialog-btn-cancel') >= 0) {

			//取消
			if (typeof ops.success == 'function') {
				ops.success({
					value: 'cancel'
				});
			}
			removeDialog();

			return false;
		}
	}

	function removeDialog() {

		var dialogView = document.querySelector('.wu-dialog');

		dialogView.classList.add('wu-animate-out');
		dialogView.addEventListener('webkitTransitionEnd', function () {
			this.remove();
		});
		document.body.removeEventListener('click', dialogHandlerr, false);
	}

	return;
};

/*
 *  显示底部弹出操作窗口
 * 
 *  @param {object} ops 相关配置
 * 
 *  wu.showAction({
		title :'示例标题',
		menuArray :[
			{ title: '示例菜单一', value: 'menu1', color: '' },
			{ title: '示例菜单二', value: 'menu2', color: 'blue'},
			{ title: 'Delete', value: 'delete', color: 'red'}      //如果是删除  value 必须是 "delete"
		],
		success: function (res) {}
	})
 */
Wu.prototype.showAction = function (ops) {

	var i,
	    len,
	    h = '';
	var title = ops.title || '',
	    deleteText = ops.deleteText,
	    menuArr = ops.menuArray || [];
	var el = document.createElement("div");

	h += '<div class="wu-mask-transparent wu-mask-black wu-mask-hide"></div>' + '<div class="wu-actionsheet-main">' + '<div class="wu-actionsheet-title">' + title + '</div>' + '<div class="wu-actionsheet-menu">';

	//遍历菜单
	if (menuArr.length) {
		for (i = 0, len = menuArr.length; i < len; i++) {
			h += '<div class="wu-btn wu-actionsheet-cell" data-value="' + menuArr[i].value + '" style="color: ' + menuArr[i].color + '">' + menuArr[i].title + '</div>';
		}
	}

	h += '</div><div class="wu-btn wu-actionsheet-cancel">取消</div></div>';

	el.className = "wu-actionsheet";
	el.innerHTML = h;

	setTimeout(function () {
		el.classList.add('wu-animate-in');
	}, 0);

	wu.addDom(el);
	wu.hoverButton();

	document.body.addEventListener('click', actionHandler, false);

	function actionHandler(e) {

		var e = e || window.event;
		var target = e.target || e.srcElement;
		var cls = target.className;

		if (cls.indexOf('wu-mask-hide') >= 0) {
			hideAction();
		}

		if (cls.indexOf('wu-actionsheet-cancel') >= 0) {
			hideAction();
		}

		if (cls.indexOf('wu-actionsheet-cell') >= 0) {

			var val = target.dataset.value,
			    //菜单显示的文本
			val_text = target.innerHTML; //菜单data值

			if (val == "delete") {

				wu.showDialog({
					title: '提示',
					content: deleteText ? deleteText : '确定删除吗？',
					showCancel: true,
					success: function success(res) {

						if (res.value == "confirm") {
							ops.success({
								value: val,
								title: val_text
							});
							hideAction();
						}
					}
				});
			} else {
				//传入参数
				if (typeof ops.success == "function") {

					ops.success({
						value: val,
						title: val_text
					});
					hideAction();
				}
			}
		}
	}

	//隐藏弹出层
	function hideAction() {

		document.querySelector('.wu-actionsheet').classList.add('wu-animate-out');
		document.querySelector('.wu-actionsheet-main').addEventListener('webkitTransitionEnd', function () {
			document.querySelector('.wu-actionsheet').remove();
		});
		document.body.removeEventListener('click', actionHandler, false);
	}
	return;
};

var wu = new Wu();

/* harmony default export */ __webpack_exports__["default"] = ({
	showMessage: function showMessage(msg) {
		wu.showMessage({
			title: msg || "",
			backgroundColor: '#fef0f0',
			color: 'red',
			duration: 3000
		});
	}
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3rpw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "47AC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5C0z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Pi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AorF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEp+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BGjt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1adbd40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.transition } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "weui-loading_toast vux-loading"
      },
      [
        _c("div", { staticClass: "weui-mask_transparent" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "weui-toast", style: { position: _vm.position } },
          [
            _c("i", { staticClass: "weui-loading weui-icon_toast" }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "weui-toast__content" },
              [_vm._v(_vm._s(_vm.text || "加载中")), _vm._t("default")],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1adbd40e", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("wq2c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vux/src/components/loading/index.vue"


/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1adbd40e", Component.options)
  } else {
    hotAPI.reload("data-v-1adbd40e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BiNk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CWjC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CvJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUD7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MK8a":
/***/ (function(module, exports) {

/**
 * 原生Date对象函数扩展
 * author : liao jiabing
 * QQ : 656317441
 * email : admin@w3c.top
 */
/**
 * 扩展Date格式化
 * @param {Object} format
 */
/* eslint-disable */
Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    "H+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds() // 毫秒
  };
  var week = {
    "0": "\u65E5",
    "1": "\u4E00",
    "2": "\u4E8C",
    "3": "\u4E09",
    "4": "\u56DB",
    "5": "\u4E94",
    "6": "\u516D"
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(format)) {
    format = format.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "\u661F\u671F" : "\u5468" : "") + week[this.getDay() + ""]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

/*
 * 方法作用：【获取日期是星期】
 * 使用方法：new Date().nowFewWeeks()
 * @param date{date} 传入日期类型
 * @returns {星期四，...}
 */
Date.prototype.nowFewWeeks = function () {
  var date = this;
  if (date instanceof Date) {
    var dayNames = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    return dayNames[date.getDay()];
  } else {
    return "Param error,date type!";
  }
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [_c("router-view")], 1)
}
var staticRenderFns = []
App_render._withStripped = true
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("AorF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./src/tools/tools.js
var tools = __webpack_require__("eBH4");

// CONCATENATED MODULE: ./src/plugin/wechatauth/WechatAuth.js





var WechatAuth_WeChatAuth = function () {
  function WeChatAuth(config) {
    classCallCheck_default()(this, WeChatAuth);

    var defaultConfig = {
      responseType: 'code',
      scope: 'snsapi_base ',
      getCodeCallback: function getCodeCallback() {}
    };
    this.config = assign_default()(defaultConfig, config);
  }

  createClass_default()(WeChatAuth, [{
    key: 'openAuthPage',
    value: function openAuthPage() {
      var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

      tools["a" /* default */].saveLog('openAuthPage', 'start');
      var redirectUriArr = redirectUri.split('#');
      window.sessionStorage.setItem('redirect_path', redirectUriArr[1]);
      redirectUri = encodeURIComponent(redirectUriArr[0]);
      this.removeAccessToken();
      this.removeAuthCode();
      var authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize';
      var authParams = '?appid=' + window.localStorage.getItem('appId') + '&redirect_uri=' + redirectUri + '&response_type=' + this.config.responseType + '&scope=' + this.config.scope + '#wechat_redirect';
      window.location.href = authPageBaseUri + authParams;
      tools["a" /* default */].saveLog('openAuthPage', 'end,location: ' + (authPageBaseUri + authParams));
    }
  }, {
    key: 'setAuthCode',
    value: function setAuthCode(code) {
      if (!code) return false;
      window.sessionStorage.setItem('auth_code', code);
      return true;
    }
  }, {
    key: 'getAuthCode',
    value: function getAuthCode() {
      var codeValue = window.sessionStorage.getItem('auth_code');
      if (!codeValue) return '';
      return codeValue;
    }
  }, {
    key: 'removeAuthCode',
    value: function removeAuthCode() {
      window.sessionStorage.removeItem('auth_code');
    }
  }, {
    key: 'removeUrlCodeQuery',
    value: function removeUrlCodeQuery() {
      var location = window.location;
      var search = location.search;
      if (search) {
        search = search.substr(1);
      }
      var href = location.origin;
      var pathName = location.pathname;
      if (pathName) {
        href += pathName;
      }
      var searchArr = search.split('&').filter(function (item) {
        if (item.indexOf('code=') !== -1) {
          return false;
        }
        if (item.indexOf('state=') !== -1) {
          return false;
        }
        return true;
      });
      if (searchArr.length > 0) {
        href += '?' + searchArr.join('&');
      }
      var hash = location.hash;
      if (hash) {
        href += hash;
      }
      window.location.href = href;
    }
  }, {
    key: 'setAccessToken',
    value: function setAccessToken(accessToken) {
      if (!accessToken) return false;
      window.localStorage.setItem('access_token', accessToken);
      return true;
    }
  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return window.localStorage.getItem('access_token');
    }
  }, {
    key: 'removeAccessToken',
    value: function removeAccessToken() {
      window.localStorage.removeItem('access_token');
    }
  }, {
    key: 'setOpenId',
    value: function setOpenId(openId) {
      window.localStorage.setItem('openId', openId);
      return true;
    }
  }, {
    key: 'getOpenId',
    value: function getOpenId() {
      return window.localStorage.getItem('openId');
    }
  }, {
    key: 'next',
    value: function next(_next) {
      var self = this;
      return function (accessToken, to) {
        if (accessToken) {
          self.setAccessToken(accessToken);
          to ? _next(to) : _next();
        } else {
          self.removeAccessToken();
          to && _next(to);
        }
        self.removeAuthCode();
      };
    }
  }, {
    key: 'getCodeCallback',
    value: function getCodeCallback(next) {
      tools["a" /* default */].saveLog('getCodeCallback', 'function');
      return this.config.getCodeCallback(this.getAuthCode(), this.next(next), window.sessionStorage.getItem('redirect_path'));
    }
  }]);

  return WeChatAuth;
}();

/* harmony default export */ var WechatAuth = (WechatAuth_WeChatAuth);
// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__("UZ5h");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// EXTERNAL MODULE: ./node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("1nuA");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// CONCATENATED MODULE: ./src/plugin/wechatauth/index.js





/* harmony default export */ var wechatauth = ({
  install: function install(Vue, options) {
    var weChatAuth = new WechatAuth(options);
    var router = options.router;
    if (!router) return false;

    function urlCodeQueryFilter(code) {
      tools["a" /* default */].saveLog('urlCodeQueryFilter', '\n        code: ' + code + '\n      ');
      if (code) {
        weChatAuth.setAuthCode(code);
        weChatAuth.removeUrlCodeQuery();
      }
    }

    function checkRouterAuth(to, from, next) {
      tools["a" /* default */].saveLog('checkRouterAuth', 'function');
      var authCode = weChatAuth.getAuthCode();
      // if ((!to.meta || !to.meta.auth) && !authCode) {
      //   alert("return 1")
      //   return true
      // }
      // alert('authCode' + authCode + '/ openId' + weChatAuth.getOpenId())
      if (!authCode && !weChatAuth.getOpenId()) {
        weChatAuth.openAuthPage(window.location.href);
        return false;
      } else if (authCode && !weChatAuth.getOpenId()) {
        weChatAuth.getCodeCallback(next);
        return false;
      }
      return true;
    }

    function beforeEach(to, from, next, str) {
      tools["a" /* default */].saveLog('beforeEach', 'function');
      var query = querystring_es3_default.a.parse(url_default.a.parse(window.location.href).query);
      var code = query.code;
      var appId = tools["a" /* default */].getUrlParams('appid');
      if (appId !== null && appId !== undefined && appId !== '') {
        window.localStorage.setItem('appId', appId);
      }
      urlCodeQueryFilter(code);
      if (!code && !checkRouterAuth(to, from, next)) {
        return false;
      }
      next();
    }

    router.beforeEach(function (to, from, next) {
      var openId = window.localStorage.getItem("openId");
      if (openId !== undefined && openId !== null && openId.indexOf("orkwnw") !== -1) {
        window.localStorage.removeItem("openId");
        window.localStorage.removeItem('access_token');
      }
      var appId = window.localStorage.getItem("appId");
      if (appId !== undefined && appId !== null && appId.indexOf("wx12a9b23a4a005be7") !== -1) {
        window.localStorage.removeItem("appId");
      }
      console.log(openId + "===" + appId);
      var path = window.location.href;
      var index = path.indexOf('/notlogin');
      var maintain = path.indexOf('/maintain');
      if (index !== -1 || maintain !== -1 || path.indexOf('/register_Test') !== -1) {
        next();
        return;
      }
      // flag = (path.indexOf('register') !== -1 || path.indexOf('ElecProtocols') !== -1)
      beforeEach(to, from, next, '');
    });
  }
});
// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__("P9l9");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/config/env.js
var config_env = __webpack_require__("uaSg");

// CONCATENATED MODULE: ./src/api/request.js

/**
 * Created by LJW on 2017/6/21.
 *
 * usage:
 * methods: {
 *    fetchData: async function () {
 *     let params = {}
 *     const res = await this.http.get(api.apiStart, params)
 *     if (res.data.success) {
 *       alert('请求成功')
 *     }
 *   }
 * }
 */



// import encrypt from '@/api/encrypt'

var wu = __webpack_require__("/uEc");
__webpack_require__("CvJx");
__webpack_require__("BiNk");

// Loading,
// let loading

axios_default.a.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return promise_default.a.reject(error);
});

axios_default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return promise_default.a.resolve(error.response);
});

// axios.defaults.withCredentials = true

function showLoading(that) {
  if (that) {
    that.$vux.loading.show({
      text: '加载中'
    });
  }
}

function hideLoading(that) {
  // window.removeLoading(name)
  if (that) {
    that.$vux.loading.hide();
  }
}

function checkStatus(response, that) {
  // requestDataBase += `
  // <p>endTime: <span style="color: red;">${new Date().getTime()}</span></p>
  // <p>北京时间(结束): <span style="color: red;">${new Date().format('yyyy-MM-dd HH:mm:ss')}</span></p>
  // `
  // sessionStorage.setItem('requestDataBase', requestDataBase)
  // 如果http状态码正常，则直接返回数据
  // if (checkCode(response, name)) {
  //   return response.data.content
  // }
  // openid
  if (response && response.returnCode === '10002') {
    var url = window.location.href;
    var index = url.indexOf('#') + 1;
    url = url.substring(0, index);
    url += '/maintain?data=' + response.returnMsg;
    window.location.href = url;
    return;
  }
  if (response.returnCode === '10013') {
    var _url = window.location.href;
    var _index = _url.indexOf('#') + 1;
    _url = _url.substring(0, _index);
    _url += '/notlogin';
    window.location.href = _url;
    return;
  }
  if (response.content === null || response.content === undefined) {
    response.content = {};
  }
  response.content.returnCode = response.returnCode;
  response.content.returnMsg = response.returnMsg;
  if (response.returnCode === '10005') {
    wu.default.showMessage(response.returnMsg);
    return response.content;
  }
  if (response.returnCode === '00000') {
    return response.content;
  }
  wu.default.showMessage(response.returnMsg);
  // 显示文字
  throw new Error('errorMsg: ' + response.returnMsg);
}

/* harmony default export */ var request = ({
  post: function post(url, data, that) {
    var flag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    // let requestDataBase = window.sessionStorage.getItem('requestDataBase') || ''
    // requestDataBase += `
    // <br/>
    // <p>------ 一点都不华丽的分割线 ------</p>
    // <p>url: <span style="color: red;">${url}</span></p>
    // <p>北京时间(开始): <span style="color: red;">${new Date().format('yyyy-MM-dd HH:mm:ss')}</span></p>
    // <p>startTime: <span style="color: red;">${new Date().getTime()}</span></p>
    // `
    showLoading(that);
    var openId = window.localStorage.getItem('openId');
    // openId = 'oLS8Sw7Q6uohBoLn4Nx6-K27C81s'
    return axios_default()({
      method: 'post',
      baseURL: config_env["a" /* baseUrl */],
      headers: { 'cpm-client-type': 'wechat', 'cpm-user-identity': openId },
      url: url,
      data: data, // encrypt.getObject(data),
      timeout: 30000
    }).then(function (response) {
      flag = false;
      hideLoading(that);
      return checkStatus(response.data, that);
    }).catch(function () {
      hideLoading(that);
      if (flag) wu.default.showMessage('网络错误');
    });
  },
  get: function get(url, params, that) {
    var flag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    showLoading(that);
    var openId = window.localStorage.getItem('openId');
    return axios_default()({
      method: 'get',
      baseURL: config_env["a" /* baseUrl */],
      headers: {
        'cpm-client-type': 'wechat',
        'cpm-user-identity': openId,
        'X-Requested-With': 'XMLHttpRequest'
      },
      url: url,
      params: params, // get 请求时带的参数
      timeout: 60000
    }).then(function (response) {
      flag = false;
      hideLoading(that);
      var result = checkStatus(response.data, that);
      flag = false;
      return result;
    }).catch(function () {
      hideLoading(that);
      if (flag) wu.default.showMessage('网络错误');
    });
  }
});
// CONCATENATED MODULE: ./src/config/WechatConfig.js


// import tools from '@/tools/tools.js'

var WechatConfig_config = function config(router) {
  return {
    router: router,
    // secret: 'eb1472b017a90d5e2327b52485e61e9b', // 微信appsecret
    responseType: 'code', // 返回类型，请填写code
    scope: 'snsapi_base', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
    getCodeCallback: function getCodeCallback(code, next, redirect) {
      // 用户同意授权后回调方法
      // code：用户同意授权后，获得code值
      // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
      // next： 无论access_token是否获取成功,一定要调用该方法
      // next说明：next方法接收两个参数
      // 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
      // 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
      // axios({
      //   method: 'post',
      //   baseUrl: baseUrl,
      //   url: getOpenId,
      //   data: {
      //     code: code,
      //     appid: window.localStorage.getItem('appId')
      //   }
      // })
      // tools.saveLog('开始获取openId', `
      //   DateTime: ${new Date().format('yyyy-MM-dd HH:mm:ss')}
      // `)
      request.post(api["l" /* getOpenId */], {
        code: code,
        appid: window.localStorage.getItem('appId')
      }).then(function (response) {
        // tools.saveLog('getOpen response', `
        //   DateTime: ${new Date().format('yyyy-MM-dd HH:mm:ss')},
        //   response: ${JSON.stringify(response)},
        //   openId: ${response['openId']}
        // `)
        var openId = response['openId'];
        if (openId) {
          window.localStorage.setItem('openId', openId);
          next(openId, redirect); // 获取access_toeken成功
        } else {
          next('', '/notlogin'); // 获取access_token失败
        }
      }).catch(function (e) {
        // tools.saveLog('getOpen error', `
        //   DateTime: ${new Date().format('yyyy-MM-dd HH:mm:ss')},
        //   path: ${window.location.href}
        // `)
        var path = window.location.href;
        var index = path.indexOf('#') + 1;
        path = path.substring(index);
        next('', path); // ajax出现错误
      });
    }
  };
};

/* harmony default export */ var WechatConfig = (WechatConfig_config);
// CONCATENATED MODULE: ./src/router/index.js





var Index = function Index() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "OtQl"));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "OwuY"));
};
var RegisterBirth = function RegisterBirth() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "LHxs"));
};
var Home = function Home() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "n/G1"));
};
// 卡卷中心
var CardCenter = function CardCenter() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "a2ur"));
};

// 卡卷中心未使用的券
var UnusedCard = function UnusedCard() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "9htQ"));
};

// 卡卷中心已使用的券
var UsedCard = function UsedCard() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "TnW6"));
};

// 卡卷中心已过期的券
var OverDueCard = function OverDueCard() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "iM0T"));
};

// 卡卷中心 => 已失效卡券
var CardCenterInvalid = function CardCenterInvalid() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "bfwp"));
};

// 个人中心
var PersonalCenter = function PersonalCenter() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "fzht"));
};

// 个人账单
var PersonalBill = function PersonalBill() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "bzf3"));
};
var Cash = function Cash() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "V83N"));
};
var Card = function Card() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "azhP"));
};
var Water = function Water() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "tY5K"));
};

// 陈列活动
var DisplayActions = function DisplayActions() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "C35v"));
};

// 赠品签收
var GiftReceipt = function GiftReceipt() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "3rhc"));
};
var Gifts = function Gifts() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "W5Ae"));
};
var Agreement = function Agreement() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "iewb"));
};

// 奖励详情
var RewardDetail = function RewardDetail() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "CAAv"));
};

// 电子协议
// const ElecProtocols = () => import('@/pages/ElecProtocols/ElecProtocols')

// 没有登录时的页面
var NotLogin = function NotLogin() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "+26p"));
};
var Maintain = function Maintain() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "bCoe"));
};

// 合同
var ElecProtocols = function ElecProtocols() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "9W1h"));
};
var ContractDetail = function ContractDetail() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "fDfs"));
};

var SearchRequestDataBase = function SearchRequestDataBase() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "atn4"));
};

// 配送评分
var DealerGradeAction = function DealerGradeAction() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "mWkP"));
};
// 业代评分
var SalesGradeAction = function SalesGradeAction() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "Xz7S"));
};
// 评分列表
var dealerGrade = function dealerGrade() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "ktla"));
};
// 评分列表
var salesGrade = function salesGrade() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "Om8M"));
};
// 业代待评价
var salesNotEvaluate = function salesNotEvaluate() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "VlMz"));
};
// 业代已评价
var salesEvaluate = function salesEvaluate() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "y4nk"));
};
// 配送商待评价
var dearNotEvaluate = function dearNotEvaluate() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "7SQI"));
};
// 配送商已评价
var dealerEvaluate = function dealerEvaluate() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "LzrN"));
};

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var base = void 0;

switch ("uat") {
  case 'dev':
    base = '';
    break;
  case 'sit':
    base = '/sit';
    break;
  default:
    base = '';
}

var router_router = new vue_router_esm["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/searchRequestDataBase',
    component: SearchRequestDataBase
  }, {
    path: '/contractDetail',
    component: ContractDetail
  }, {
    path: '/notlogin',
    name: '华润怡宝',
    component: NotLogin
  }, {
    path: '/maintain',
    name: '维护',
    component: Maintain
  }, {
    path: '/register',
    name: '绑定',
    component: Register
  }, {
    path: '/register_birth',
    name: '绑定',
    component: RegisterBirth
  }, {
    path: base + '/customer-wechat/index.html',
    name: 'cpm-customer-wechat1',
    component: Index
  }, {
    path: '/',
    name: 'cpm-customer-wechat2',
    component: Index
  }, {
    path: '/index',
    name: 'cpm-customer-wechat3',
    component: Index,
    children: [{
      path: '/',
      name: '首页',
      component: Home
    }, {
      path: '/home',
      name: '首页',
      component: Home
    }, {
      path: '/cardCenter',
      name: '代金券中心',
      component: CardCenter,

      children: [{
        path: '/unusedCard',
        name: '',
        component: UnusedCard
      }, {
        path: '/usedCard',
        name: '',
        component: UsedCard
      }, {
        path: '/overDueCard',
        name: '',
        component: OverDueCard
      }, {
        path: '/',
        name: '',
        component: UnusedCard
      }]
    }, {
      path: '/cardCenterInvalid',
      name: '',
      component: CardCenterInvalid
    }, {
      path: '/personalCenter',
      name: '个人中心',
      component: PersonalCenter
    }, {
      path: '/GiftReceipt',
      name: '签收中心',
      component: GiftReceipt,
      children: [{
        path: '/gifts',
        component: Gifts
      }, {
        path: '/agreement',
        name: '待签协议',
        component: Agreement
      }, {
        path: '/',
        name: '',
        component: Gifts
      }]
    }, {
      path: '/displayActions',
      name: '陈列活动',
      component: DisplayActions
    }, {
      path: '/PersonalBill',
      name: '个人账单',
      component: PersonalBill,
      children: [{
        path: '/cash',
        component: Cash
      }, {
        path: '/card',
        component: Card
      }, {
        path: '/water',
        component: Water
      }, {
        path: '/',
        component: Cash
      }]
    }, {
      path: '/RewardDetail',
      name: '奖励详情',
      component: RewardDetail
    }, {
      path: '/ElecProtocols',
      name: '协议签署',
      component: ElecProtocols
    }, {
      path: '/dealerGradeAction',
      name: '配送评分',
      component: DealerGradeAction
    }, {
      path: '/salesGradeAction',
      name: '业代评分',
      component: SalesGradeAction
    }, {
      path: '/dealerGrade',
      name: '评分页面',
      component: dealerGrade,
      children: [{
        path: '/dearNotEvaluate',
        name: '配送商待评价',
        component: dearNotEvaluate
      }, {
        path: '/dealerEvaluate',
        name: '配送商已评价',
        component: dealerEvaluate
      }]
    }, {
      path: '/salesGrade',
      name: '评分页面',
      component: salesGrade,
      children: [{
        path: '/salesNotEvaluate',
        name: '业代待评价',
        component: salesNotEvaluate
      }, {
        path: '/salesEvaluate',
        name: '业代已评价',
        component: salesEvaluate
      }]
    }]
  }]
});

// 微信授权插件初始化
if (config_env["b" /* env */] !== '') {
  vue_esm["a" /* default */].use(wechatauth, WechatConfig(router_router));
}

/* harmony default export */ var src_router = (router_router);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/global/global.js


var _mutations;

var types = {
  SHOW_TOAST: 'show_toast',
  HIDE_TOAST: 'hide_toast',
  SHOW_LOADING: 'show_loading',
  HIDE_LOADING: 'hide_loading'
};

var state = {
  toast: { isShow: false },
  isLoading: false
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, types.SHOW_TOAST, function (state, payload) {
  state.toast.isShow = true;
  state.toast.msg = payload.msg;
  state.toast.type = payload.type;
}), defineProperty_default()(_mutations, types.HIDE_TOAST, function (state) {
  state.toast.isShow = false;
}), defineProperty_default()(_mutations, types.SHOW_LOADING, function (state) {
  state.isLoading = true;
}), defineProperty_default()(_mutations, types.HIDE_LOADING, function (state) {
  state.isLoading = false;
}), _mutations);

var actions = {
  showToast: function showToast(_ref, payload) {
    var commit = _ref.commit;

    commit(types.SHOW_TOAST, payload);
  },
  hideToast: function hideToast(_ref2) {
    var commit = _ref2.commit;

    commit(types.HIDE_TOAST);
  },
  showLoading: function showLoading(_ref3) {
    var commit = _ref3.commit;

    commit(types.SHOW_LOADING);
  },
  hideLoading: function hideLoading(_ref4) {
    var commit = _ref4.commit;

    commit(types.HIDE_LOADING);
  }
};

/* harmony default export */ var global = ({
  state: state,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/global/index.js

/* harmony default export */ var store_global = (global);
// CONCATENATED MODULE: ./src/store/user/user.js

var user_types = {
  WECHAT_OPEN_ID: 'wechat_open_id'
};

var user_state = {
  openId: ''
};

var user_mutations = defineProperty_default()({}, user_types.WECHAT_OPEN_ID, function (state, payload) {
  state.openId = payload.openId;
});

var user_actions = {
  setOpenId: function setOpenId(_ref, payload) {
    var commit = _ref.commit;

    commit(user_types.WECHAT_OPEN_ID, payload);
  }
};

/* harmony default export */ var user = ({
  state: user_state,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/user/index.js

/* harmony default export */ var store_user = (user);
// CONCATENATED MODULE: ./src/store/data/getters.js
/* harmony default export */ var getters = ({
  getData: function getData(state) {
    return state.database;
  },
  getWater: function getWater(state) {
    return state.PersonalBill.Water;
  },
  getCard: function getCard(state) {
    return state.PersonalBill.Card;
  },
  getCash: function getCash(state) {
    return state.PersonalBill.Cash;
  },
  getPersonalBil: function getPersonalBil(state) {
    return state.PersonalBill;
  },
  getTitle: function getTitle(state) {
    return state.title;
  }
});
// CONCATENATED MODULE: ./src/store/data/mutations.js


var mutations_state = {
  database: {
    // TODO...
  },
  PersonalBill: {
    Water: {},
    Cash: {},
    Card: {}
  },
  title: 'cpm-customer-wechat'
};

var mutations_mutations = {
  setData: function setData(state, jsonObj) {
    for (var key in jsonObj) {
      state.database[key] = jsonObj[key];
    }
  },
  removeData: function removeData(state, key) {
    delete state.database[key];
  },
  setWater: function setWater(state, jsonObj) {
    var tempWater = {};
    for (var key in jsonObj) {
      tempWater[key] = jsonObj[key];
    }
    state.PersonalBill.Water = tempWater;
  },
  setCash: function setCash(state, jsonObj) {
    var tempCash = {};
    // debugger
    for (var key in jsonObj) {
      tempCash[key] = jsonObj[key];
    }
    state.PersonalBill.Cash = tempCash;
  },
  setCard: function setCard(state, jsonObj) {
    var tempCard = {};
    for (var key in jsonObj) {
      tempCard[key] = jsonObj[key];
    }
    state.PersonalBill.Card = tempCard;
  },
  setTitle: function setTitle(state, title) {
    state.title = title;
  }
};

/* harmony default export */ var data_mutations = ({
  state: mutations_state,
  mutations: mutations_mutations,
  getters: getters
});
// CONCATENATED MODULE: ./src/store/data/actions.js
/* harmony default export */ var data_actions = ({
  setData: function setData(_ref, obj) {
    var commit = _ref.commit;

    commit('setData', obj);
  },
  removeData: function removeData(_ref2, key) {
    var commit = _ref2.commit;

    commit('removeData', key);
  },
  setWater: function setWater(_ref3, obj) {
    var commit = _ref3.commit;

    commit('setWater', obj);
  },
  setCard: function setCard(_ref4, obj) {
    var commit = _ref4.commit;

    commit('setCard', obj);
  },
  setCash: function setCash(_ref5, obj) {
    var commit = _ref5.commit;

    commit('setCash', obj);
  },
  setTitle: function setTitle(_ref6, title) {
    var commit = _ref6.commit;

    commit('setTitle', title);
  }
});
// CONCATENATED MODULE: ./src/store/data/index.js



/* harmony default export */ var store_data = ({
  modules: {
    mutations: data_mutations
  },
  actions: data_actions
});
// CONCATENATED MODULE: ./src/store/index.js






vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    global: store_global,
    user: store_user,
    data: store_data
  }
}));
// EXTERNAL MODULE: ./src/tools/ArrayExtend.js
var ArrayExtend = __webpack_require__("eRIG");
var ArrayExtend_default = /*#__PURE__*/__webpack_require__.n(ArrayExtend);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("oVYx");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appHeader/App-header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App_header = ({
  data: function data() {
    return {};
  },

  methods: {
    toHome: function toHome() {
      this.$router.push({ path: '/home' });
    },
    menuClick: function menuClick(path, query) {
      if (typeof path !== 'string') return;
      if (query === undefined) {
        this.$router.replace(path);
      } else {
        this.$router.push({
          'path': path,
          query: query
        });
      }
    },
    showDialog: function showDialog() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var menuDialog = this.$refs.menuDialog;
      try {
        // bounceOut
        if (flag) {
          //            this.showUserDialog(false)
          menuDialog.classList.toggle('show');
        } else {
          menuDialog.classList.remove('show');
        }
      } catch (e) {
        // console.log(e)
      }
    },
    showUserDialog: function showUserDialog() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.$router.push({ path: '/personalCenter' }); // 点击直接跳转至个人中心页面
      //        let userDialog = this.$refs.userDialog
      //        try {
      //          if (flag) {
      //            this.showDialog(false)
      //            userDialog.classList.toggle('show')
      //          } else {
      //            userDialog.classList.remove('show')
      //          }
      //        } catch (e) {
      //          // console.log(e)
      //        }
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.document.body.addEventListener('click', function (e) {
      e = e || window.event;
      var target = e.target;
      if (target.className === 'menu app-header-menu' || target.className === 'persion app-header-user app-mr10') return;
      _this.showDialog(false);
      //        _this.showUserDialog(false)
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appHeader/App-header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var appHeader_App_header = ({
  data: function data() {
    return {};
  },

  methods: {
    toHome: function toHome() {
      this.$router.push({ path: '/home' });
    },
    menuClick: function menuClick(path, query) {
      if (typeof path !== 'string') return;
      if (query === undefined) {
        this.$router.replace(path);
      } else {
        this.$router.push({
          'path': path,
          query: query
        });
      }
    },
    showDialog: function showDialog() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var menuDialog = this.$refs.menuDialog;
      try {
        // bounceOut
        if (flag) {
          //            this.showUserDialog(false)
          menuDialog.classList.toggle('show');
        } else {
          menuDialog.classList.remove('show');
        }
      } catch (e) {
        // console.log(e)
      }
    },
    showUserDialog: function showUserDialog() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.$router.push({ path: '/personalCenter' }); // 点击直接跳转至个人中心页面
      //        let userDialog = this.$refs.userDialog
      //        try {
      //          if (flag) {
      //            this.showDialog(false)
      //            userDialog.classList.toggle('show')
      //          } else {
      //            userDialog.classList.remove('show')
      //          }
      //        } catch (e) {
      //          // console.log(e)
      //        }
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.document.body.addEventListener('click', function (e) {
      e = e || window.event;
      var target = e.target;
      if (target.className === 'menu app-header-menu' || target.className === 'persion app-header-user app-mr10') return;
      _this.showDialog(false);
      //        _this.showUserDialog(false)
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b716a152","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appHeader/App-header.vue
var App_header_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "app-header app-pr" }, [
    _c("div", { staticClass: "left-box" }, [
      _c("div", {
        staticClass: "persion app-header-user app-mr10",
        on: {
          click: function($event) {
            return _vm.showUserDialog(true)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "logo-box", on: { click: _vm.toHome } }, [
      _c("div", { staticClass: "logo app-fl" }),
      _vm._v(" "),
      _c("div", { staticClass: "text app-fl" }, [_vm._v("首页")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right-box" }, [
      _c("div", {
        staticClass: "menu app-header-menu",
        on: {
          click: function($event) {
            return _vm.showDialog(true)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "menuDialog",
        staticClass: "header-dialog app-pa",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "sanjiao" }),
        _vm._v(" "),
        _c("div", { staticClass: "menu-list" }, [
          _c("ul", [
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("cardCenter")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left1" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            代金券中心\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("personalBill")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left2" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            个人账单\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("giftReceipt")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left3" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            签收中心\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("displayActions")
                  }
                }
              },
              [
                _c("div", { staticClass: "left left4" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            陈列活动\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("dealerGrade", { role: "Dealer" })
                  }
                }
              },
              [
                _c("div", { staticClass: "left left5" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            配送评价\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.menuClick("salesGrade", { role: "Sales" })
                  }
                }
              },
              [
                _c("div", { staticClass: "left left6" }),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v("\n            业代评价\n          ")
                ])
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", {
      ref: "userDialog",
      staticClass: "header-dialog header-user-dialog app-pa",
      staticStyle: { display: "none" }
    })
  ])
}
var App_header_staticRenderFns = []
App_header_render._withStripped = true
var App_header_esExports = { render: App_header_render, staticRenderFns: App_header_staticRenderFns }
/* harmony default export */ var simple_appHeader_App_header = (App_header_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b716a152", App_header_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appHeader/App-header.vue
var App_header_disposed = false
function App_header_injectStyle (ssrContext) {
  if (App_header_disposed) return
  __webpack_require__("BEp+")
}
var App_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_header___vue_template_functional__ = false
/* styles */
var App_header___vue_styles__ = App_header_injectStyle
/* scopeId */
var App_header___vue_scopeId__ = "data-v-b716a152"
/* moduleIdentifier (server only) */
var App_header___vue_module_identifier__ = null
var App_header_Component = App_header_normalizeComponent(
  appHeader_App_header,
  simple_appHeader_App_header,
  App_header___vue_template_functional__,
  App_header___vue_styles__,
  App_header___vue_scopeId__,
  App_header___vue_module_identifier__
)
App_header_Component.options.__file = "src/components/simple/appHeader/App-header.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b716a152", App_header_Component.options)
  } else {
    hotAPI.reload("data-v-b716a152", App_header_Component.options)
  }
  module.hot.dispose(function (data) {
    App_header_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appHeader_App_header = (App_header_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appHeader/index.js


/* harmony default export */ var appHeader = ({
  install: function install(Vue) {
    Vue.component('app-header', components_simple_appHeader_App_header);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appSelectBar/App-select-bar.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App_select_bar = ({
  data: function data() {
    return {};
  },

  props: {
    data: {
      default: []
    }
  },
  computed: {
    getListStyle: function getListStyle() {
      var len = this.data.length;
      var width = 100 / len;
      return 'width: ' + width + '%';
    }
  },
  methods: {
    selectBarClick: function selectBarClick(item) {
      this.data.forEach(function (e) {
        e.display = false;
      });
      item.display = true;
      this.$emit('currentChange', item);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appSelectBar/App-select-bar.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var appSelectBar_App_select_bar = ({
  data: function data() {
    return {};
  },

  props: {
    data: {
      default: []
    }
  },
  computed: {
    getListStyle: function getListStyle() {
      var len = this.data.length;
      var width = 100 / len;
      return 'width: ' + width + '%';
    }
  },
  methods: {
    selectBarClick: function selectBarClick(item) {
      this.data.forEach(function (e) {
        e.display = false;
      });
      item.display = true;
      this.$emit('currentChange', item);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cceefcc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appSelectBar/App-select-bar.vue
var App_select_bar_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-select-bar app-oh animated fadeIn" }, [
    _c(
      "ul",
      { staticClass: "list-box clearfix" },
      _vm._l(_vm.data, function(item) {
        return _c(
          "li",
          {
            staticClass: "app-pr",
            style: _vm.getListStyle,
            on: {
              click: function($event) {
                return _vm.selectBarClick(item)
              }
            }
          },
          [
            _vm._v("\n      " + _vm._s(item.text) + "\n      "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.display,
                  expression: "item.display"
                }
              ],
              staticClass: "hr app-pa"
            })
          ]
        )
      }),
      0
    )
  ])
}
var App_select_bar_staticRenderFns = []
App_select_bar_render._withStripped = true
var App_select_bar_esExports = { render: App_select_bar_render, staticRenderFns: App_select_bar_staticRenderFns }
/* harmony default export */ var simple_appSelectBar_App_select_bar = (App_select_bar_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cceefcc", App_select_bar_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appSelectBar/App-select-bar.vue
var App_select_bar_disposed = false
function App_select_bar_injectStyle (ssrContext) {
  if (App_select_bar_disposed) return
  __webpack_require__("nKLN")
}
var App_select_bar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_select_bar___vue_template_functional__ = false
/* styles */
var App_select_bar___vue_styles__ = App_select_bar_injectStyle
/* scopeId */
var App_select_bar___vue_scopeId__ = "data-v-0cceefcc"
/* moduleIdentifier (server only) */
var App_select_bar___vue_module_identifier__ = null
var App_select_bar_Component = App_select_bar_normalizeComponent(
  appSelectBar_App_select_bar,
  simple_appSelectBar_App_select_bar,
  App_select_bar___vue_template_functional__,
  App_select_bar___vue_styles__,
  App_select_bar___vue_scopeId__,
  App_select_bar___vue_module_identifier__
)
App_select_bar_Component.options.__file = "src/components/simple/appSelectBar/App-select-bar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0cceefcc", App_select_bar_Component.options)
  } else {
    hotAPI.reload("data-v-0cceefcc", App_select_bar_Component.options)
  }
  module.hot.dispose(function (data) {
    App_select_bar_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appSelectBar_App_select_bar = (App_select_bar_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appSelectBar/index.js


/* harmony default export */ var appSelectBar = ({
  install: function install(Vue) {
    Vue.component('app-select-bar', components_simple_appSelectBar_App_select_bar);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appButton/App-button.vue
//
//
//
//

/* harmony default export */ var App_button = ({
  props: {
    value: {
      default: ''
    }
  },
  methods: {
    clickEvent: function clickEvent() {
      this.$emit('click');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appButton/App-button.vue
//
//
//
//

/* harmony default export */ var appButton_App_button = ({
  props: {
    value: {
      default: ''
    }
  },
  methods: {
    clickEvent: function clickEvent() {
      this.$emit('click');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c95392","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appButton/App-button.vue
var App_button_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "app-button",
      attrs: { href: "javascript:void(0);" },
      on: { click: _vm.clickEvent }
    },
    [_vm._v(_vm._s(_vm.value))]
  )
}
var App_button_staticRenderFns = []
App_button_render._withStripped = true
var App_button_esExports = { render: App_button_render, staticRenderFns: App_button_staticRenderFns }
/* harmony default export */ var simple_appButton_App_button = (App_button_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0c95392", App_button_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appButton/App-button.vue
var App_button_disposed = false
function App_button_injectStyle (ssrContext) {
  if (App_button_disposed) return
  __webpack_require__("CWjC")
}
var App_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_button___vue_template_functional__ = false
/* styles */
var App_button___vue_styles__ = App_button_injectStyle
/* scopeId */
var App_button___vue_scopeId__ = "data-v-c0c95392"
/* moduleIdentifier (server only) */
var App_button___vue_module_identifier__ = null
var App_button_Component = App_button_normalizeComponent(
  appButton_App_button,
  simple_appButton_App_button,
  App_button___vue_template_functional__,
  App_button___vue_styles__,
  App_button___vue_scopeId__,
  App_button___vue_module_identifier__
)
App_button_Component.options.__file = "src/components/simple/appButton/App-button.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0c95392", App_button_Component.options)
  } else {
    hotAPI.reload("data-v-c0c95392", App_button_Component.options)
  }
  module.hot.dispose(function (data) {
    App_button_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appButton_App_button = (App_button_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appButton/index.js


/* harmony default export */ var appButton = ({
  install: function install(Vue) {
    Vue.component('app-button', components_simple_appButton_App_button);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appButtonCircle/App-button-circle.vue
//
//
//
//

/* harmony default export */ var App_button_circle = ({
  props: {
    active: {
      default: false
    },
    value: {
      default: ''
    },
    background: {
      default: '#5DBFB9'
    }
  },
  methods: {
    buttonClick: function buttonClick() {
      // this.active = true
      this.$emit('update:active', true);
      this.$emit('click');
    }
  },
  computed: {
    getButtonStyle: function getButtonStyle() {
      if (this.active) {
        return 'background: ' + this.background;
      }
      return 'background:  #D2D2D2';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appButtonCircle/App-button-circle.vue
//
//
//
//

/* harmony default export */ var appButtonCircle_App_button_circle = ({
  props: {
    active: {
      default: false
    },
    value: {
      default: ''
    },
    background: {
      default: '#5DBFB9'
    }
  },
  methods: {
    buttonClick: function buttonClick() {
      // this.active = true
      this.$emit('update:active', true);
      this.$emit('click');
    }
  },
  computed: {
    getButtonStyle: function getButtonStyle() {
      if (this.active) {
        return 'background: ' + this.background;
      }
      return 'background:  #D2D2D2';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e47d74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appButtonCircle/App-button-circle.vue
var App_button_circle_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "app-button-circle",
      style: _vm.getButtonStyle,
      attrs: { href: "javascript:void(0);" },
      on: { click: _vm.buttonClick }
    },
    [_vm._v(_vm._s(_vm.value))]
  )
}
var App_button_circle_staticRenderFns = []
App_button_circle_render._withStripped = true
var App_button_circle_esExports = { render: App_button_circle_render, staticRenderFns: App_button_circle_staticRenderFns }
/* harmony default export */ var simple_appButtonCircle_App_button_circle = (App_button_circle_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59e47d74", App_button_circle_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appButtonCircle/App-button-circle.vue
var App_button_circle_disposed = false
function App_button_circle_injectStyle (ssrContext) {
  if (App_button_circle_disposed) return
  __webpack_require__("niLN")
}
var App_button_circle_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_button_circle___vue_template_functional__ = false
/* styles */
var App_button_circle___vue_styles__ = App_button_circle_injectStyle
/* scopeId */
var App_button_circle___vue_scopeId__ = "data-v-59e47d74"
/* moduleIdentifier (server only) */
var App_button_circle___vue_module_identifier__ = null
var App_button_circle_Component = App_button_circle_normalizeComponent(
  appButtonCircle_App_button_circle,
  simple_appButtonCircle_App_button_circle,
  App_button_circle___vue_template_functional__,
  App_button_circle___vue_styles__,
  App_button_circle___vue_scopeId__,
  App_button_circle___vue_module_identifier__
)
App_button_circle_Component.options.__file = "src/components/simple/appButtonCircle/App-button-circle.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59e47d74", App_button_circle_Component.options)
  } else {
    hotAPI.reload("data-v-59e47d74", App_button_circle_Component.options)
  }
  module.hot.dispose(function (data) {
    App_button_circle_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appButtonCircle_App_button_circle = (App_button_circle_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appButtonCircle/index.js


/* harmony default export */ var appButtonCircle = ({
  install: function install(Vue) {
    Vue.component('app-button-circle', components_simple_appButtonCircle_App_button_circle);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appDate/App-date.vue


/* harmony default export */ var App_date = ({
  data: function data() {
    return {
      Value: this.value,
      readonly: false
    };
  },

  props: {
    value: {
      default: ''
    }
  },
  methods: {
    dateClick: function dateClick() {
      var _this = this;
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD',
        value: '2017-05-20 18',
        onConfirm: function onConfirm(val) {
          _this.Value = val;
          _this.$emit('update:value', val);
          _this.$emit('change', val);
        },
        onShow: function onShow() {},
        onHide: function onHide() {}
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appDate/App-date.vue


/* harmony default export */ var appDate_App_date = ({
  data: function data() {
    return {
      Value: this.value,
      readonly: false
    };
  },

  props: {
    value: {
      default: ''
    }
  },
  methods: {
    dateClick: function dateClick() {
      var _this = this;
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD',
        value: '2017-05-20 18',
        onConfirm: function onConfirm(val) {
          _this.Value = val;
          _this.$emit('update:value', val);
          _this.$emit('change', val);
        },
        onShow: function onShow() {},
        onHide: function onHide() {}
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c41d9c12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appDate/App-date.vue
var App_date_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text" }, [
    _vm._v("\n    " + _vm._s(_vm.Value) + "  "),
    _c("div", { staticClass: "app-date", on: { click: _vm.dateClick } }),
    _vm._v(" "),
    _c("div", { staticClass: "icon" })
  ])
}
var App_date_staticRenderFns = []
App_date_render._withStripped = true
var App_date_esExports = { render: App_date_render, staticRenderFns: App_date_staticRenderFns }
/* harmony default export */ var simple_appDate_App_date = (App_date_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c41d9c12", App_date_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appDate/App-date.vue
var App_date_disposed = false
function App_date_injectStyle (ssrContext) {
  if (App_date_disposed) return
  __webpack_require__("h1gC")
}
var App_date_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_date___vue_template_functional__ = false
/* styles */
var App_date___vue_styles__ = App_date_injectStyle
/* scopeId */
var App_date___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App_date___vue_module_identifier__ = null
var App_date_Component = App_date_normalizeComponent(
  appDate_App_date,
  simple_appDate_App_date,
  App_date___vue_template_functional__,
  App_date___vue_styles__,
  App_date___vue_scopeId__,
  App_date___vue_module_identifier__
)
App_date_Component.options.__file = "src/components/simple/appDate/App-date.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c41d9c12", App_date_Component.options)
  } else {
    hotAPI.reload("data-v-c41d9c12", App_date_Component.options)
  }
  module.hot.dispose(function (data) {
    App_date_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appDate_App_date = (App_date_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appDate/index.js


/* harmony default export */ var appDate = ({
  install: function install(Vue) {
    Vue.component('app-date', components_simple_appDate_App_date);
  }
});
// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appConfirmDialog/App-confirm-dialog.vue



/* harmony default export */ var App_confirm_dialog = ({
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  data: function data() {
    return {};
  },

  props: {
    show: {
      default: false
    }
  },
  methods: {
    exit: function exit() {
      this.$emit('update:show', false);
    },
    close: function close() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    confirm: function confirm() {
      this.$emit('confirm');
      this.$emit('update:show', false);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appConfirmDialog/App-confirm-dialog.vue



/* harmony default export */ var appConfirmDialog_App_confirm_dialog = ({
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  data: function data() {
    return {};
  },

  props: {
    show: {
      default: false
    }
  },
  methods: {
    exit: function exit() {
      this.$emit('update:show', false);
    },
    close: function close() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    confirm: function confirm() {
      this.$emit('confirm');
      this.$emit('update:show', false);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80c06008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appConfirmDialog/App-confirm-dialog.vue
var App_confirm_dialog_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-confirm-dialog" },
    [
      _c(
        "x-dialog",
        {
          staticClass: "app-confirm-dialog-position app-pr",
          attrs: { show: _vm.show }
        },
        [
          _c("div", { staticClass: "top" }),
          _vm._v(" "),
          _c("div", { staticClass: "center app-oh" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("\n        温馨提示\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("\n        请确认促销折扣实物已全部送达及验收\n      ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottom" }, [
            _c("div", { staticClass: "bottom-left", on: { click: _vm.exit } }, [
              _vm._v("\n        取消\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom-right", on: { click: _vm.confirm } },
              [_vm._v("\n        确定\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-box" }, [
            _c("div", { staticClass: "icon" })
          ])
        ]
      )
    ],
    1
  )
}
var App_confirm_dialog_staticRenderFns = []
App_confirm_dialog_render._withStripped = true
var App_confirm_dialog_esExports = { render: App_confirm_dialog_render, staticRenderFns: App_confirm_dialog_staticRenderFns }
/* harmony default export */ var simple_appConfirmDialog_App_confirm_dialog = (App_confirm_dialog_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80c06008", App_confirm_dialog_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appConfirmDialog/App-confirm-dialog.vue
var App_confirm_dialog_disposed = false
function App_confirm_dialog_injectStyle (ssrContext) {
  if (App_confirm_dialog_disposed) return
  __webpack_require__("HUD7")
}
var App_confirm_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_confirm_dialog___vue_template_functional__ = false
/* styles */
var App_confirm_dialog___vue_styles__ = App_confirm_dialog_injectStyle
/* scopeId */
var App_confirm_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App_confirm_dialog___vue_module_identifier__ = null
var App_confirm_dialog_Component = App_confirm_dialog_normalizeComponent(
  appConfirmDialog_App_confirm_dialog,
  simple_appConfirmDialog_App_confirm_dialog,
  App_confirm_dialog___vue_template_functional__,
  App_confirm_dialog___vue_styles__,
  App_confirm_dialog___vue_scopeId__,
  App_confirm_dialog___vue_module_identifier__
)
App_confirm_dialog_Component.options.__file = "src/components/simple/appConfirmDialog/App-confirm-dialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-80c06008", App_confirm_dialog_Component.options)
  } else {
    hotAPI.reload("data-v-80c06008", App_confirm_dialog_Component.options)
  }
  module.hot.dispose(function (data) {
    App_confirm_dialog_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appConfirmDialog_App_confirm_dialog = (App_confirm_dialog_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appConfirmDialog/index.js


/* harmony default export */ var appConfirmDialog = ({
  install: function install(Vue) {
    Vue.component('app-confirm-dialog', components_simple_appConfirmDialog_App_confirm_dialog);
  }
});
// EXTERNAL MODULE: ./src/components/simple/appSortList/iconfont/iconfont.css
var iconfont = __webpack_require__("U3QL");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appSortList/App-sort-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var App_sort_list = ({
  data: function data() {
    return {
      checked: true,
      down: 'down iconfont icon-paixujiantouxia app-pa',
      top: 'top iconfont icon-paixujiantoushang app-pa',
      state: 'default',
      flag: true
    };
  },

  props: {
    data: {
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    getLiStyle: function getLiStyle() {
      var len = this.data.length;
      var width = 100 / len;
      return 'width: ' + width + '%;';
    }
  },
  watch: {
    state: function state() {
      this.update();
    }
  },
  methods: {
    update: function update() {
      this.flag = false;
      this.$nextTick(function () {
        this.flag = true;
      });
    },
    getTopStyle: function getTopStyle(item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'asc';
          return 'asc top iconfont icon-paixujiantoushang app-pa';
        case 'desc':
          item.sort = 'desc';
          return 'desc top down iconfont icon-paixujiantoushang app-pa';
        default:
          item.sort = 'default';
          return 'top iconfont icon-paixujiantoushang app-pa';
      }
    },
    getDownStyle: function getDownStyle(item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'asc';
          return 'asc down iconfont icon-paixujiantouxia app-pa';
        case 'desc':
          item.sort = 'desc';
          return 'desc down iconfont icon-paixujiantouxia app-pa';
        default:
          item.sort = 'default';
          return ' down iconfont icon-paixujiantouxia app-pa';
      }
    },
    toggleState: function toggleState(item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'desc';
          this.state = 'desc';
          this.down = 'desc down iconfont icon-paixujiantouxia app-pa';
          this.top = 'desc top iconfont icon-paixujiantoushang app-pa';
          break;
        case 'desc':
          item.sort = 'default';
          this.state = 'default';
          this.down = 'down iconfont icon-paixujiantouxia app-pa';
          this.top = 'top iconfont icon-paixujiantoushang app-pa';
          break;
        default:
          item.sort = 'asc';
          this.state = 'asc';
          this.down = 'asc down iconfont icon-paixujiantouxia app-pa';
          this.top = 'asc top iconfont icon-paixujiantoushang app-pa';
          break;
      }
      item.change(item.sort);
      // console.log(this.data)
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appSortList/App-sort-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var appSortList_App_sort_list = ({
  data: function data() {
    return {
      checked: true,
      down: 'down iconfont icon-paixujiantouxia app-pa',
      top: 'top iconfont icon-paixujiantoushang app-pa',
      state: 'default',
      flag: true
    };
  },

  props: {
    data: {
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    getLiStyle: function getLiStyle() {
      var len = this.data.length;
      var width = 100 / len;
      return 'width: ' + width + '%;';
    }
  },
  watch: {
    state: function state() {
      this.update();
    }
  },
  methods: {
    update: function update() {
      this.flag = false;
      this.$nextTick(function () {
        this.flag = true;
      });
    },
    getTopStyle: function getTopStyle(item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'asc';
          return 'asc top iconfont icon-paixujiantoushang app-pa';
        case 'desc':
          item.sort = 'desc';
          return 'desc top down iconfont icon-paixujiantoushang app-pa';
        default:
          item.sort = 'default';
          return 'top iconfont icon-paixujiantoushang app-pa';
      }
    },
    getDownStyle: function getDownStyle(item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'asc';
          return 'asc down iconfont icon-paixujiantouxia app-pa';
        case 'desc':
          item.sort = 'desc';
          return 'desc down iconfont icon-paixujiantouxia app-pa';
        default:
          item.sort = 'default';
          return ' down iconfont icon-paixujiantouxia app-pa';
      }
    },
    toggleState: function toggleState(item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'desc';
          this.state = 'desc';
          this.down = 'desc down iconfont icon-paixujiantouxia app-pa';
          this.top = 'desc top iconfont icon-paixujiantoushang app-pa';
          break;
        case 'desc':
          item.sort = 'default';
          this.state = 'default';
          this.down = 'down iconfont icon-paixujiantouxia app-pa';
          this.top = 'top iconfont icon-paixujiantoushang app-pa';
          break;
        default:
          item.sort = 'asc';
          this.state = 'asc';
          this.down = 'asc down iconfont icon-paixujiantouxia app-pa';
          this.top = 'asc top iconfont icon-paixujiantoushang app-pa';
          break;
      }
      item.change(item.sort);
      // console.log(this.data)
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b5761a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appSortList/App-sort-list.vue
var App_sort_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-sort-list clearfix" }, [
    _vm.flag
      ? _c(
          "ul",
          { staticClass: "list-box" },
          _vm._l(_vm.data, function(item) {
            return _c("li", { style: _vm.getLiStyle }, [
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.toggleState(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item.text))]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "iconfont-box" }, [
                _c("i", { class: _vm.getTopStyle(item) }),
                _vm._v(" "),
                _c("i", { class: _vm.getDownStyle(item) })
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var App_sort_list_staticRenderFns = []
App_sort_list_render._withStripped = true
var App_sort_list_esExports = { render: App_sort_list_render, staticRenderFns: App_sort_list_staticRenderFns }
/* harmony default export */ var simple_appSortList_App_sort_list = (App_sort_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b5761a2", App_sort_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appSortList/App-sort-list.vue
var App_sort_list_disposed = false
function App_sort_list_injectStyle (ssrContext) {
  if (App_sort_list_disposed) return
  __webpack_require__("QNZy")
}
var App_sort_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_sort_list___vue_template_functional__ = false
/* styles */
var App_sort_list___vue_styles__ = App_sort_list_injectStyle
/* scopeId */
var App_sort_list___vue_scopeId__ = "data-v-0b5761a2"
/* moduleIdentifier (server only) */
var App_sort_list___vue_module_identifier__ = null
var App_sort_list_Component = App_sort_list_normalizeComponent(
  appSortList_App_sort_list,
  simple_appSortList_App_sort_list,
  App_sort_list___vue_template_functional__,
  App_sort_list___vue_styles__,
  App_sort_list___vue_scopeId__,
  App_sort_list___vue_module_identifier__
)
App_sort_list_Component.options.__file = "src/components/simple/appSortList/App-sort-list.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b5761a2", App_sort_list_Component.options)
  } else {
    hotAPI.reload("data-v-0b5761a2", App_sort_list_Component.options)
  }
  module.hot.dispose(function (data) {
    App_sort_list_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appSortList_App_sort_list = (App_sort_list_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appSortList/index.js


/* harmony default export */ var appSortList = ({
  install: function install(Vue) {
    Vue.component('app-sort-list', components_simple_appSortList_App_sort_list);
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/components/simple/empty/images/empty.png
var empty = __webpack_require__("X8cD");
var empty_default = /*#__PURE__*/__webpack_require__.n(empty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/empty/App-empty.vue


//
//
//
//
//
//
//


/* harmony default export */ var App_empty = ({
  data: function data() {
    return {
      emptyImg: empty_default.a
    };
  },

  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/empty/App-empty.vue


//
//
//
//
//
//
//


/* harmony default export */ var empty_App_empty = ({
  data: function data() {
    return {
      emptyImg: empty_default.a
    };
  },

  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8386f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/empty/App-empty.vue
var App_empty_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center", height: "100%" } },
    [
      _c("img", { staticClass: "img", attrs: { src: _vm.emptyImg } }),
      _vm._v(" "),
      _c("div", { staticClass: "tips" }, [_vm._v("什么都没有~")])
    ]
  )
}
var App_empty_staticRenderFns = []
App_empty_render._withStripped = true
var App_empty_esExports = { render: App_empty_render, staticRenderFns: App_empty_staticRenderFns }
/* harmony default export */ var simple_empty_App_empty = (App_empty_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e8386f2", App_empty_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/empty/App-empty.vue
var App_empty_disposed = false
function App_empty_injectStyle (ssrContext) {
  if (App_empty_disposed) return
  __webpack_require__("V3pR")
}
var App_empty_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_empty___vue_template_functional__ = false
/* styles */
var App_empty___vue_styles__ = App_empty_injectStyle
/* scopeId */
var App_empty___vue_scopeId__ = "data-v-4e8386f2"
/* moduleIdentifier (server only) */
var App_empty___vue_module_identifier__ = null
var App_empty_Component = App_empty_normalizeComponent(
  empty_App_empty,
  simple_empty_App_empty,
  App_empty___vue_template_functional__,
  App_empty___vue_styles__,
  App_empty___vue_scopeId__,
  App_empty___vue_module_identifier__
)
App_empty_Component.options.__file = "src/components/simple/empty/App-empty.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e8386f2", App_empty_Component.options)
  } else {
    hotAPI.reload("data-v-4e8386f2", App_empty_Component.options)
  }
  module.hot.dispose(function (data) {
    App_empty_disposed = true
  })
})()}

/* harmony default export */ var components_simple_empty_App_empty = (App_empty_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/empty/index.js


/* harmony default export */ var simple_empty = ({
  install: function install(Vue) {
    Vue.component('app-empty', components_simple_empty_App_empty);
  }
});
// EXTERNAL MODULE: ./src/components/simple/appWrong/images/wrong.png
var wrong = __webpack_require__("WEJk");
var wrong_default = /*#__PURE__*/__webpack_require__.n(wrong);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appWrong/App-wrong.vue


//
//
//
//
//
//
//


/* harmony default export */ var App_wrong = ({
  data: function data() {
    return {
      wrongImg: wrong_default.a
    };
  },

  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appWrong/App-wrong.vue


//
//
//
//
//
//
//


/* harmony default export */ var appWrong_App_wrong = ({
  data: function data() {
    return {
      wrongImg: wrong_default.a
    };
  },

  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-765df6bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appWrong/App-wrong.vue
var App_wrong_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center", "margin-top": "100px" } },
    [
      _c("img", { staticClass: "img", attrs: { src: _vm.wrongImg } }),
      _vm._v(" "),
      _c("div", { staticClass: "tips" }, [_vm._v("出错了，请稍后再试~")])
    ]
  )
}
var App_wrong_staticRenderFns = []
App_wrong_render._withStripped = true
var App_wrong_esExports = { render: App_wrong_render, staticRenderFns: App_wrong_staticRenderFns }
/* harmony default export */ var simple_appWrong_App_wrong = (App_wrong_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-765df6bb", App_wrong_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appWrong/App-wrong.vue
var App_wrong_disposed = false
function App_wrong_injectStyle (ssrContext) {
  if (App_wrong_disposed) return
  __webpack_require__("SAE/")
}
var App_wrong_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_wrong___vue_template_functional__ = false
/* styles */
var App_wrong___vue_styles__ = App_wrong_injectStyle
/* scopeId */
var App_wrong___vue_scopeId__ = "data-v-765df6bb"
/* moduleIdentifier (server only) */
var App_wrong___vue_module_identifier__ = null
var App_wrong_Component = App_wrong_normalizeComponent(
  appWrong_App_wrong,
  simple_appWrong_App_wrong,
  App_wrong___vue_template_functional__,
  App_wrong___vue_styles__,
  App_wrong___vue_scopeId__,
  App_wrong___vue_module_identifier__
)
App_wrong_Component.options.__file = "src/components/simple/appWrong/App-wrong.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-765df6bb", App_wrong_Component.options)
  } else {
    hotAPI.reload("data-v-765df6bb", App_wrong_Component.options)
  }
  module.hot.dispose(function (data) {
    App_wrong_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appWrong_App_wrong = (App_wrong_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appWrong/index.js


/* harmony default export */ var appWrong = ({
  install: function install(Vue) {
    Vue.component('app-wrong', components_simple_appWrong_App_wrong);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appTipsDialog/App-tips-dialog.vue





/* harmony default export */ var App_tips_dialog = ({
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  data: function data() {
    return {};
  },

  props: {
    tips: String, // 定义传值的类型
    show: false
  },
  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    close: function close() {

      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/simple/appTipsDialog/App-tips-dialog.vue





/* harmony default export */ var appTipsDialog_App_tips_dialog = ({
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  data: function data() {
    return {};
  },

  props: {
    tips: String, // 定义传值的类型
    show: false
  },
  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    close: function close() {

      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b28bba94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appTipsDialog/App-tips-dialog.vue
var App_tips_dialog_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-confirm-dialog" },
    [
      _c(
        "x-dialog",
        {
          staticClass: "app-confirm-dialog-position app-pr",
          attrs: { show: _vm.show }
        },
        [
          _c("div", [
            _c("div", { staticClass: "text" }, [
              _vm._v("\n        " + _vm._s(_vm.tips) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn", on: { click: _vm.close } }, [
            _vm._v("\n      确定\n    ")
          ])
        ]
      )
    ],
    1
  )
}
var App_tips_dialog_staticRenderFns = []
App_tips_dialog_render._withStripped = true
var App_tips_dialog_esExports = { render: App_tips_dialog_render, staticRenderFns: App_tips_dialog_staticRenderFns }
/* harmony default export */ var simple_appTipsDialog_App_tips_dialog = (App_tips_dialog_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b28bba94", App_tips_dialog_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/simple/appTipsDialog/App-tips-dialog.vue
var App_tips_dialog_disposed = false
function App_tips_dialog_injectStyle (ssrContext) {
  if (App_tips_dialog_disposed) return
  __webpack_require__("NbrP")
}
var App_tips_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App_tips_dialog___vue_template_functional__ = false
/* styles */
var App_tips_dialog___vue_styles__ = App_tips_dialog_injectStyle
/* scopeId */
var App_tips_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App_tips_dialog___vue_module_identifier__ = null
var App_tips_dialog_Component = App_tips_dialog_normalizeComponent(
  appTipsDialog_App_tips_dialog,
  simple_appTipsDialog_App_tips_dialog,
  App_tips_dialog___vue_template_functional__,
  App_tips_dialog___vue_styles__,
  App_tips_dialog___vue_scopeId__,
  App_tips_dialog___vue_module_identifier__
)
App_tips_dialog_Component.options.__file = "src/components/simple/appTipsDialog/App-tips-dialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b28bba94", App_tips_dialog_Component.options)
  } else {
    hotAPI.reload("data-v-b28bba94", App_tips_dialog_Component.options)
  }
  module.hot.dispose(function (data) {
    App_tips_dialog_disposed = true
  })
})()}

/* harmony default export */ var components_simple_appTipsDialog_App_tips_dialog = (App_tips_dialog_Component.exports);

// CONCATENATED MODULE: ./src/components/simple/appTipsDialog/index.js


/* harmony default export */ var appTipsDialog = ({
  install: function install(Vue) {
    Vue.component('app-tips-dialog', components_simple_appTipsDialog_App_tips_dialog);
  }
});
// CONCATENATED MODULE: ./src/components/index.js


// import common from './global/common/'










vue_esm["a" /* default */].use(appSortList);
vue_esm["a" /* default */].use(appConfirmDialog);
vue_esm["a" /* default */].use(appDate);
vue_esm["a" /* default */].use(appButtonCircle);
vue_esm["a" /* default */].use(appButton);
vue_esm["a" /* default */].use(appHeader);
vue_esm["a" /* default */].use(appSelectBar);
vue_esm["a" /* default */].use(simple_empty);
vue_esm["a" /* default */].use(appWrong);
vue_esm["a" /* default */].use(appTipsDialog);
// Vue.use(common)
// EXTERNAL MODULE: ./src/style/animate.min.css
var animate_min = __webpack_require__("BGjt");
var animate_min_default = /*#__PURE__*/__webpack_require__.n(animate_min);

// EXTERNAL MODULE: ./src/tools/DateExtend.js
var DateExtend = __webpack_require__("MK8a");
var DateExtend_default = /*#__PURE__*/__webpack_require__.n(DateExtend);

// EXTERNAL MODULE: ./node_modules/@elastic/apm-rum/dist/es/index.js + 42 modules
var es = __webpack_require__("GPHg");

// EXTERNAL MODULE: ./node_modules/@com.capgemini.cn/crbr-api-server/index.js
var crbr_api_server = __webpack_require__("qEW7");
var crbr_api_server_default = /*#__PURE__*/__webpack_require__.n(crbr_api_server);

// CONCATENATED MODULE: ./src/plugin/monitoring.js





var urlData = {
  'cpmcust.crbeverage.com': 'pro', // prod
  'cpmcust-uat.crbeverage.com': 'uat', // uat
  'fat': 'fat',
  'dev': 'dev'

  // 初始化埋点
};function init(data, env) {
  Object(es["a" /* init */])({
    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: 'cpm-cust-wechat',

    // Set custom APM Server URL (default: http://localhost:8200)
    serverUrl: data,

    // Set service version (required for sourcemap feature)
    serviceVersion: '',
    environment: env
  });
}

var monitoring_requestAmpUrl = function requestAmpUrl() {
  // 动态获取埋点地址
  return new promise_default.a(function (resolve, reject) {
    crbr_api_server["Domain"].getEnvUrl('commonUrl', urlData, undefined, true).then(function (res) {
      if (res.data) {
        var ampUrl = res.data['apm-rum-server'];
        Object(config_env["d" /* setAmpUrl */])(ampUrl);
        init(ampUrl, res.env);
        resolve();
      }
    }).catch(function (err) {
      alert(err.msg);
    });
  });
};
// CONCATENATED MODULE: ./src/doman.js



// import { setUrl } from '@/api/api'
var doman_urlData = {
  'cpmcust.crbeverage.com': 'pro', // prod
  'cpmcust-uat.crbeverage.com': 'uat', // uat
  'fat': 'fat',
  'sit': 'fat'
};

var doman_requestRemoteIp = function requestRemoteIp() {
  // 动态获取
  return new promise_default.a(function (resolve, reject) {
    crbr_api_server["Domain"].getEnvUrl('cpmUrl', doman_urlData, 'wechat-cust', true).then(function (res) {
      if (res.data) {
        // if (res.data['server-id']) {
        //   setUrl(res.data['server-id'])
        // }
        res.data['wechat-cust'] ? Object(config_env["e" /* setBaseUrl */])(res.data['wechat-cust']) : Object(config_env["e" /* setBaseUrl */])('http://cpmapi-uat.crbeverage.com'); // dev
        resolve();
      }
    }).catch(function (err) {
      console.log(err);
      // alert(err.msg)
    });
  });
};
// CONCATENATED MODULE: ./src/apiUrl.js




var apiUrl_requestGetApiUrl = function requestGetApiUrl() {
  // 动态获取APIURL地址
  return new promise_default.a(function (resolve, reject) {
    // 动态获取后台服务API请求URL
    crbr_api_server["Domain"].getServiceMap('serviceMapUrl', undefined, true).then(function (res) {
      if (res.data) {
        Object(api["z" /* setApiUrl */])(res.data);
        resolve();
      }
    }).catch(function (err) {
      alert(err.msg);
    });
  });
};
// EXTERNAL MODULE: ./node_modules/vconsole/dist/vconsole.min.js
var vconsole_min = __webpack_require__("Lw6n");
var vconsole_min_default = /*#__PURE__*/__webpack_require__.n(vconsole_min);

// CONCATENATED MODULE: ./src/vconsole.js

var time = 0;
var timer = null;
window.addEventListener('click', function (e) {
  handleClick(e);
}, { passive: false });

function handleClick(e) {
  clearTimeout(timer);
  if (e.pageX < 150 && e.pageY < 150) {
    time++;
    if (time >= 10) {
      var vs = new vconsole_min_default.a();
      console.log('出现vconsole1111', vs);
    }
  }
  timer = setTimeout(function () {
    time = 0;
  }, 500);
}
// CONCATENATED MODULE: ./src/main.js
























vue_esm["a" /* default */].use(datetime["a" /* default */]);

vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].prototype.http = request;

vue_esm["a" /* default */].config.productionTip = false;

src_router.beforeEach(function (to, from, next) {
  try {
    window.document.title = to.name || to.matched[1].name;
  } catch (e) {}
  next();
});

src_router.afterEach(function (to) {});

promise_default.a.all([monitoring_requestAmpUrl(), doman_requestRemoteIp(), apiUrl_requestGetApiUrl()]).then(function (_) {
  new vue_esm["a" /* default */]({
    router: src_router,
    store: store,
    render: function render(h) {
      return h(src_App);
    }
  }).$mount('#app-box');
});
/* eslint-disable no-new */

/***/ }),

/***/ "NbrP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setApiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getMsgCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return submitPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return submitBirth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return loginStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cardCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return notice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cardCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return readGiftReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return confirmGiftReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return gainProcotol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return confirmProtocol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return readAgreement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return personalBill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return displayAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getOpenId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getProofUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDetailUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return rebateDetailUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return homeBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAgreementContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reviewDistributorlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return reviewSaleslist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return reviewTaglist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return reviewSalescreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reviewDistributorcreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return vaildGrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cartonqrcode; });
var getMsgCode = void 0,
    submitPhone = void 0,
    submitBirth = void 0,
    loginStatus = void 0,
    cardCenter = void 0,
    notice = void 0,
    cardCode = void 0,
    readGiftReceipt = void 0,
    confirmGiftReceipt = void 0,
    gainProcotol = void 0,
    confirmProtocol = void 0,
    readAgreement = void 0,
    personalBill = void 0,
    displayAction = void 0,
    actionDetail = void 0,
    getOpenId = void 0,
    getProofUrl = void 0,
    getDetailUrl = void 0,
    rebateDetailUrl = void 0,
    homeBanner = void 0,
    getAgreementContract = void 0,
    reviewDistributorlist = void 0,
    reviewSaleslist = void 0,
    reviewTaglist = void 0,
    reviewSalescreate = void 0,
    reviewDistributorcreate = void 0,
    vaildGrade = void 0,
    cartonqrcode = void 0;

var moduleName = 'wechat-cust.';

var setApiUrl = function setApiUrl(urlMap) {
  getMsgCode = urlMap[moduleName + 'getMsgCode'];
  submitPhone = urlMap[moduleName + 'submitPhone'];
  submitBirth = urlMap[moduleName + 'submitBirth'];
  loginStatus = urlMap[moduleName + 'loginStatus'];
  cardCenter = urlMap[moduleName + 'cardCenter'];
  notice = urlMap[moduleName + 'notice'];
  cardCode = urlMap[moduleName + 'cardCode'];
  readGiftReceipt = urlMap[moduleName + 'readGiftReceipt'];
  confirmGiftReceipt = urlMap[moduleName + 'confirmGiftReceipt'];
  gainProcotol = urlMap[moduleName + 'gainProcotol'];
  confirmProtocol = urlMap[moduleName + 'confirmProtocol'];
  readAgreement = urlMap[moduleName + 'readAgreement'];
  personalBill = urlMap[moduleName + 'personalBill'];
  displayAction = urlMap[moduleName + 'displayAction'];
  actionDetail = urlMap[moduleName + 'actionDetail'];
  getOpenId = urlMap[moduleName + 'getOpenId'];
  getProofUrl = urlMap[moduleName + 'getProofUrl'];
  getDetailUrl = urlMap[moduleName + 'getDetailUrl'];
  rebateDetailUrl = urlMap[moduleName + 'rebateDetailUrl'];
  homeBanner = urlMap[moduleName + 'homeBanner'];
  getAgreementContract = urlMap[moduleName + 'getAgreementContract'];
  reviewDistributorlist = urlMap[moduleName + 'reviewDistributorlist'];
  reviewSaleslist = urlMap[moduleName + 'reviewSaleslist'];
  reviewTaglist = urlMap[moduleName + 'reviewTaglist'];
  reviewSalescreate = urlMap[moduleName + 'reviewSalescreate'];
  reviewDistributorcreate = urlMap[moduleName + 'reviewDistributorcreate'];
  vaildGrade = urlMap[moduleName + 'vaildGrade'];
  cartonqrcode = urlMap[moduleName + 'cartonqrcode'];
};

// export const setUrl = module => {
//   const tp = module.tp
//   const basic = module.basic
//   const contract = module.contract
//   getMsgCode = basic + 'wcv1/user/smscode'
//   submitPhone = basic + 'wcv1/user/mobilemodify'
//   submitBirth = basic + 'wcv1/user/birthdaymodify'
//   loginStatus = basic + 'wcv1/user/bindstatus'
//   cardCenter = tp + 'wcv1/card/search'
//   notice = tp + 'wcv1/card/notice'
//   cardCode = basic + 'wcv1/card/qrcode'
//   readGiftReceipt = tp + 'wcv1/rebatesku/list'
//   confirmGiftReceipt = tp + 'wcv1/rebatesku/comfirm'
//   gainProcotol = contract + 'wcv1/agreement/djtldetail'
//   confirmProtocol = tp + 'wcv1/agreement/confirm'
//   readAgreement = tp + 'wcv1/agreement/unconfirmlist'
//   personalBill = tp + 'wcv1/rebate/list'
//   displayAction = tp + 'wcv1/agreement/list'
//   actionDetail = basic + 'wcv1/user/detail'
//   getOpenId = tp + 'wcv1/user/getopenid'
//   getProofUrl = tp + 'wcv1/agreement/rebatecert'
//   getDetailUrl = tp + 'wcv1/agreement/agreementdetail'
//   rebateDetailUrl = tp + 'wcv1/agreement/rebatedetail'
//   homeBanner = basic + 'wcv1/banner/list'
//   getAgreementContract = tp + 'wcv1/agreement/getAgreementContract'
//   reviewDistributorlist = basic + 'wcv1/review/distributorlist'
//   reviewSaleslist = basic + 'wcv1/review/saleslist'
//   reviewTaglist = basic + 'wcv1/review/taglist'
//   reviewSalescreate = basic + 'wcv1/review/salescreate'
//   reviewDistributorcreate = basic + 'wcv1/review/distributorcreate'
//   vaildGrade = basic + 'wcv1/review/checkvalide'
//   cartonqrcode = basic + 'wcv1/user/cartonqrcode'
// }
// 获取短信验证码
// export const getMsgCode = 'cpm-basic-management/wcv1/user/smscode'
// export const getMsgCode = basic + 'wcv1/user/smscode'

// 微信绑定手机提交
// export const submitPhone = 'cpm-basic-management/wcv1/user/mobilemodify'
// export const submitPhone = basic + 'wcv1/user/mobilemodify'

// 修改商户生日提交
// export const submitBirth = 'cpm-basic-management/wcv1/user/birthdaymodify'
// export const submitBirth = basic + 'wcv1/user/birthdaymodify'

// 商户绑定状态
// export const loginStatus = 'cpm-basic-management/wcv1/user/bindstatus'
// export const loginStatus = basic + 'wcv1/user/bindstatus'

// 卡券中心
// export const cardCenter = 'cpm-tp-management/wcv1/card/search'
// export const cardCenter = tp + 'wcv1/card/search'

// 卡券详情
// export const notice = 'cpm-tp-management/wcv1/card/notice'
// export const notice = tp + 'wcv1/card/notice'

// export const cardCode = 'cpm-basic-management/wcv1/card/qrcode'
// export const cardCode = basic + 'wcv1/card/qrcode'

// 赠品签收读取
// export const readGiftReceipt = 'cpm-tp-management/wcv1/rebatesku/list'
// export const readGiftReceipt = tp + 'wcv1/rebatesku/list'

// 赠品签收提交
// export const confirmGiftReceipt = 'cpm-tp-management/wcv1/rebatesku/comfirm'
// export const confirmGiftReceipt = tp + 'wcv1/rebatesku/comfirm'

// 协议获取
// export const gainProcotol = 'cpm-digital-contract/wcv1/agreement/djtldetail'
// export const gainProcotol = contract + 'wcv1/agreement/djtldetail'

// 协议确认
// export const confirmProtocol = 'cpm-tp-management/wcv1/agreement/confirm'
// export const confirmProtocol = tp + 'wcv1/agreement/confirm'

// 待签协议读取gainProcotol
// export const readAgreement = 'cpm-tp-management/wcv1/agreement/unconfirmlist'
// export const readAgreement = tp + 'wcv1/agreement/unconfirmlist'

// 个人账单
// export const personalBill = 'cpm-tp-management/wcv1/rebate/list'
// export const personalBill = tp + 'wcv1/rebate/list'

// 陈列活动
// export const displayAction = 'cpm-tp-management/wcv1/agreement/list'
// export const displayAction = tp + 'wcv1/agreement/list'

// 活动详情
// export const actionDetail = 'cpm-basic-management/wcv1/user/detail'
// export const actionDetail = basic + 'wcv1/user/detail'

// 获取openid
// export const getOpenId = 'cpm-tp-management/wcv1/user/getopenid'
// export const getOpenId = tp + 'wcv1/user/getopenid'
// 协议返还详情-返还凭证读取
// export const getProofUrl = 'cpm-tp-management/wcv1/agreement/rebatecert'
// export const getProofUrl = tp + 'wcv1/agreement/rebatecert'

// 协议返还详情-签约详情读取
// export const getDetailUrl = 'cpm-tp-management/wcv1/agreement/agreementdetail'
// export const getDetailUrl = tp + 'wcv1/agreement/agreementdetail'

// 协议返还详情读取
// export const rebateDetailUrl = 'cpm-tp-management/wcv1/agreement/rebatedetail'
// export const rebateDetailUrl = tp + 'wcv1/agreement/rebatedetail'

// 首页banner
// export const homeBanner = 'cpm-basic-management/wcv1/banner/list'
// export const homeBanner = basic + 'wcv1/banner/list'

// export const getAgreementContract = 'cpm-tp-management/wcv1/agreement/getAgreementContract'
// export const getAgreementContract = tp + 'wcv1/agreement/getAgreementContract'

// 配送商评论读取
// export const reviewDistributorlist = 'cpm-basic-management/wcv1/review/distributorlist'
// export const reviewDistributorlist = basic + 'wcv1/review/distributorlist'
// 业代评论读取
// export const reviewSaleslist = 'cpm-basic-management/wcv1/review/saleslist'
// export const reviewSaleslist = basic + 'wcv1/review/saleslist'
// 评论标签读取
// export const reviewTaglist = 'cpm-basic-management/wcv1/review/taglist'
// export const reviewTaglist = basic + 'wcv1/review/taglist'
// 业代评论提交
// export const reviewSalescreate = 'cpm-basic-management/wcv1/review/salescreate'
// export const reviewSalescreate = basic + 'wcv1/review/salescreate'
// 配送商评论提交
// export const reviewDistributorcreate = 'cpm-basic-management/wcv1/review/distributorcreate'
// export const reviewDistributorcreate = basic + 'wcv1/review/distributorcreate'
// 检查评价是否可用
// export const vaildGrade = 'cpm-basic-management/wcv1/review/checkvalide'
// export const vaildGrade = basic + 'wcv1/review/checkvalide'

// 商户纸箱二维码
// export const cartonqrcode = 'cpm-basic-management/wcv1/user/cartonqrcode'
// export const cartonqrcode = basic + 'wcv1/user/cartonqrcode'



/***/ }),

/***/ "QNZy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SAE/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U3QL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3pR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WEJk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wrong.9630d71.png";

/***/ }),

/***/ "X8cD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty.d99d0d0.png";

/***/ }),

/***/ "bAAk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBH4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import axios from '@/api/request.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取url参数
   * 如不传任何参数,则返回所有key-value
   */
  getUrlParams: function getUrlParams(key) {
    try {
      var vars = [];
      var hash = [];
      var indx = window.location.href.indexOf('#');
      var str = window.location.href.substring(indx);
      var hashes = str.slice(str.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      if (key && typeof key === 'string') {
        for (var _i = 0; _i < vars.length; _i++) {
          if (key === vars[_i]) {
            var value = vars[key];
            return value;
          }
        }
        return null;
      }
      return vars;
    } catch (e) {
      return null;
    }
  },
  saveLog: function saveLog() {
    // try {
    //   message += `
    //     URL: ${window.location.href}
    //   `
    //   axios.post('cpm-digital-coupon/wc1/log/printlog', {
    //     tag,
    //     message
    //   }, undefined, false)
    // } catch (e) {
    //   // TODO...
    // }

    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  }
});

/***/ }),

/***/ "eRIG":
/***/ (function(module, exports) {

/**
 * 原生数组函数扩展
 * author : liao jiabing
 * QQ : 656317441
 * email : admin@w3c.top
 */
/**
 * 清空数组
 * @returns {Array}
 */
/* eslint-disable */
Array.prototype.clear = function () {
  for (var i = this.length; i >= 0; i--) {
    this.splice(i, 1);
  }
  return this;
};

/**
 * 返回item中数组中的位置
 * @param item
 * @returns {number}
 */
Array.prototype.indexOf = function (item) {
  if (this.length === 0) return -1;
  for (var i = 0, len = this.length; i < len; i++) {
    if (this[i] === item) {
      return i;
    }
  }
  return -1;
};

Array.prototype.removeIndex = function (index) {
  this.splice(index, 1);
};

/**
 * 判断是否存在指定元素
 * @param item
 * @returns {boolean}
 */
Array.prototype.exists = function (item) {
  return item === null ? false : this.indexOf(item) !== -1;
};

/**
 * 获取数组中第一个元素
 * @returns {null}
 */
Array.prototype.first = function () {
  return this.length === 0 ? null : this[0];
};

/**
 * 获取数组最后一个元素
 * @returns {null}
 */
Array.prototype.last = function () {
  return this.length === 0 ? null : this[this.length - 1];
};

/**
 * 克隆一个数组
 * @returns {Array.<T>}
 */
Array.prototype.clone = function () {
  return this.slice(0);
};

/**
 * 删除指定元素
 * @param item
 * @returns {*}
 */
Array.prototype.remove = function (item) {
  var itemIndex = this.indexOf(item);
  if (itemIndex >= 0) {
    this.splice(itemIndex, 1);
    return itemIndex;
  }
  return -1;
};

/**
 * 删除多个元素
 * @param arr
 */
Array.prototype.removeAll = function () {
  for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  for (var i = 0, len = items.length; i < len; i++) {
    this.remove(items[i]);
  }
  return this;
};

Array.prototype.add = function () {
  for (var _len2 = arguments.length, arr = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    arr[_key2] = arguments[_key2];
  }

  for (var i = 0, len = arr.length; i < len; i++) {
    this.push(arr[i]);
  }
  return this;
};

/**
 * 添加多个元素
 * @param arr
 */
Array.prototype.addAll = function (arr) {
  for (var i = 0, len = arr.length; i < len; i++) {
    this.push(arr[i]);
  }
  return this;
};

/**
 * 获取数组大小
 */
Array.prototype.size = function () {
  return this.length;
};

/**
 * 数组去重
 */
Array.prototype.unique = function () {
  this.sort();
  var re = [this[0]];
  for (var i = 1; i < this.length; i++) {
    if (this[i] !== re[re.length - 1]) {
      re.push(this[i]);
    }
  }
  return re;
};

/**
 * 数字数组由小到大排序
 */
Array.prototype.min2Max = function () {
  var oValue;
  for (var i = 0; i < this.length; i++) {
    for (var j = 0; j <= i; j++) {
      if (this[i] < this[j]) {
        oValue = this[i];
        this[i] = this[j];
        this[j] = oValue;
      }
    }
  }
  return this;
};

/**
 * 数字数组由大到小排序
 */
Array.prototype.max2Min = function () {
  var oValue;
  for (var i = 0; i < this.length; i++) {
    for (var j = 0; j <= i; j++) {
      if (this[i] > this[j]) {
        oValue = this[i];
        this[i] = this[j];
        this[j] = oValue;
      }
    }
  }
  return this;
};

/**
 * 获得数字数组中最大项
 */
Array.prototype.getMax = function () {
  var oValue = 0;
  for (var i = 0; i < this.length; i++) {
    if (this[i] > oValue) {
      oValue = this[i];
    }
  }
  return oValue;
};

/**
 * 获得数字数组中最小项
 */
Array.prototype.getMin = function () {
  var oValue = 0;
  for (var i = 0; i < this.length; i++) {
    if (this[i] < oValue) {
      oValue = this[i];
    }
  }
  return oValue;
};

/**
 * 在数组的指定位置加元素
 */
Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

/***/ }),

/***/ "h1gC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570115ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vux-alert" },
    [
      _c(
        "x-dialog",
        {
          attrs: {
            "mask-transition": _vm.maskTransition,
            "dialog-transition": _vm.dialogTransition,
            "hide-on-blur": _vm.hideOnBlur,
            "mask-z-index": _vm.maskZIndex
          },
          on: {
            "on-hide": function($event) {
              return _vm.$emit("on-hide")
            },
            "on-show": function($event) {
              return _vm.$emit("on-show")
            }
          },
          model: {
            value: _vm.showValue,
            callback: function($$v) {
              _vm.showValue = $$v
            },
            expression: "showValue"
          }
        },
        [
          _c("div", { staticClass: "weui-dialog__hd" }, [
            _c("strong", { staticClass: "weui-dialog__title" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "weui-dialog__bd" },
            [
              _vm._t("default", [
                _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "weui-dialog__ft" }, [
            _c(
              "a",
              {
                staticClass: "weui-dialog__btn weui-dialog__btn_primary",
                attrs: { href: "javascript:;" },
                on: { click: _vm._onHide }
              },
              [_vm._v(_vm._s(_vm.buttonText || "确定"))]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-570115ee", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("47AC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vux/src/components/alert/index.vue"


/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-570115ee", Component.options)
  } else {
    hotAPI.reload("data-v-570115ee", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKLN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "niLN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ee3e0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vux-toast" },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowMask && _vm.show,
            expression: "isShowMask && show"
          }
        ],
        staticClass: "weui-mask_transparent"
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: _vm.currentTransition } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show"
              }
            ],
            staticClass: "weui-toast",
            class: _vm.toastClass,
            style: { width: _vm.width }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type !== "text",
                  expression: "type !== 'text'"
                }
              ],
              staticClass: "weui-icon-success-no-circle weui-icon_toast"
            }),
            _vm._v(" "),
            _vm.text
              ? _c("p", {
                  staticClass: "weui-toast__content",
                  style: _vm.style,
                  domProps: { innerHTML: _vm._s(_vm.text) }
                })
              : _c(
                  "p",
                  { staticClass: "weui-toast__content", style: _vm.style },
                  [_vm._t("default")],
                  2
                )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14ee3e0e", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("7Pi5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vux/src/components/toast/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14ee3e0e", Component.options)
  } else {
    hotAPI.reload("data-v-14ee3e0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseUrl; });
/* unused harmony export routerMode */
/* unused harmony export baseImgPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return env; });
/* unused harmony export ampUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setAmpUrl; });
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 * apmUrl: 埋点地址
 */
var baseUrl = '';
var routerMode = 'history';
var baseImgPath = 'http://images.cangdu.org/';
var openId = 'ohSeq0TOhWRxYG3wCb8LkkFwzEvA';
var env = '';
var ampUrl = '';

switch ("uat") {
  case 'dev':
    // dev: 10.208.38.27:8080
    // sit: 10.208.39.43:8080
    baseUrl = 'http://cpmapi-uat.crbeverage.com/';
    openId = window.localStorage.getItem('openId');
    env = 'dev';
    ampUrl = 'http://apm-server.crbr.com';
    break;
  case 'sit':
    // baseUrl = 'http://10.0.182.211:8080/'
    baseUrl = 'http://wxapp-dev.crbeverage.com/sit/';
    openId = window.localStorage.getItem('openId');
    env = 'sit';
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server';
    break;
  case 'prod':
    // baseUrl = 'http://cpmapi.crbeverage.com/cpm-api-getway/'
    baseUrl = 'http://cpmapi.crbeverage.com/';
    openId = window.localStorage.getItem('openId');
    env = 'prod';
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server';
    break;
  case 'uat':
    // baseUrl = 'http://cpmapi-uat.crbeverage.com/cpm-api-getway/'
    baseUrl = 'http://cpmapi-uat.crbeverage.com/';
    // baseUrl = 'http://wxapp-dev.crbeverage.com/'
    openId = window.localStorage.getItem('openId');
    env = 'uat';
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server';
    break;
  default:
    baseUrl = 'http://cpmapi-uat.crbeverage.com/';
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server';
    // baseUrl = 'http://10.208.61.17:8080/'
    // baseUrl = 'http://wxapp-dev.crbeverage.com/'
    // baseUrl = 'http://10.208.39.59:8111/mockjs/7/'
    // openId = 'oLS8Sw7Q6uohBoLn4Nx6-K27C81s'
    // baseUrl = 'http://cpmapi.crbeverage.com/'
    // oLS8SwzU4alHtRVf0mrDb_2pJ1NY
    // window.localStorage.setItem('openId', 'oFqOL1gkTYQiyC32FD37jEZOUw-E')
    // window.localStorage.setItem('openId', 'oFqOL1n7_7PlhEQUMHdhE4szKyc0')
    window.localStorage.setItem('openId', 'oNfIowSQJ7663xstL4Jq5Pofg6h4');
    openId = window.localStorage.getItem('openId');
    env = '';
    break;
}

var setBaseUrl = function setBaseUrl(url) {
  baseUrl = url + '/';
};

var setAmpUrl = function setAmpUrl(url) {
  ampUrl = url;
};



/***/ }),

/***/ "wq2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e9d1a18bc09c5d887a41.js